import { render, staticRenderFns } from "./extreme-report.vue?vue&type=template&id=7860573e&scoped=true"
import script from "./extreme-report.vue?vue&type=script&lang=js"
export * from "./extreme-report.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=7860573e&prod&scoped=true&lang=css&external"
import style1 from "./extreme-report.vue?vue&type=style&index=1&id=7860573e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7860573e",
  null
  
)

export default component.exports